import { WeekdayFlag } from './../models/models.swagger.generated';
/* eslint-disable no-bitwise */
import { WeekdayNumbers } from 'luxon';

export interface IWeekdays {
  allowedMonday: boolean;
  allowedTuesday: boolean;
  allowedWednesday: boolean;
  allowedThursday: boolean;
  allowedFriday: boolean;
  allowedSaturday: boolean;
  allowedSunday: boolean;
}

export class WeekDayFlagsHelper {

  public static WEEK_DAY_FLAG_WORKING_DAYS = WeekdayFlag.Monday | WeekdayFlag.Tuesday | WeekdayFlag.Wednesday | WeekdayFlag.Thursday | WeekdayFlag.Friday;
  public static WEEK_DAY_FLAG_WEEKEND = WeekdayFlag.Saturday | WeekdayFlag.Sunday;
  public static WEEK_DAY_FLAG_ALL_DAYS = WeekDayFlagsHelper.WEEK_DAY_FLAG_WORKING_DAYS | WeekDayFlagsHelper.WEEK_DAY_FLAG_WEEKEND;
  public static WEEK_DAY_FLAG_NONE = 0 as WeekdayFlag;

  public static daysToFlag(weekdays: IWeekdays): WeekdayFlag {
    let weekdaysFlag = WeekDayFlagsHelper.WEEK_DAY_FLAG_NONE;
    if (weekdays?.allowedMonday) {
      weekdaysFlag += WeekdayFlag.Monday;
    }
    if (weekdays?.allowedTuesday) {
      weekdaysFlag += WeekdayFlag.Tuesday;
    }
    if (weekdays?.allowedWednesday) {
      weekdaysFlag += WeekdayFlag.Wednesday;
    }
    if (weekdays?.allowedThursday) {
      weekdaysFlag += WeekdayFlag.Thursday;
    }
    if (weekdays?.allowedFriday) {
      weekdaysFlag += WeekdayFlag.Friday;
    }
    if (weekdays?.allowedSaturday) {
      weekdaysFlag += WeekdayFlag.Saturday;
    }
    if (weekdays?.allowedSunday) {
      weekdaysFlag += WeekdayFlag.Sunday;
    }
    return weekdaysFlag;
  }

  public static luxonWeekdayToFlag(weekday: WeekdayNumbers): WeekdayFlag {
    return 1 << (weekday - 1);
  }

  public static hasFlags(source: WeekdayFlag, daysToCheckFor: WeekdayFlag) {
    return !!(source & daysToCheckFor);
  }

  public static shiftFlagsOneDayBack(dayFlag: WeekdayFlag): WeekdayFlag
  {
      // monday becomes sunday, ...
      const overflowAdd = WeekDayFlagsHelper.hasFlags(dayFlag, WeekdayFlag.Monday) ? WeekdayFlag.Sunday : 0;
      const val = dayFlag >> 1 + overflowAdd;
      return val;
  }

  public static shiftFlagsOneDayForward(dayFlag: WeekdayFlag): WeekdayFlag
  {
      // sunday becomes monday, ...
      const overflowAdd = WeekDayFlagsHelper.hasFlags(dayFlag, WeekdayFlag.Sunday) ? WeekdayFlag.Monday : 0;
      const val = (dayFlag << 1) & WeekDayFlagsHelper.WEEK_DAY_FLAG_ALL_DAYS | overflowAdd;
      return val;
  }
}
